import { useEffect, useState } from "react";

import { BannerPayload } from "../types";
import { fetchBanner } from "../services/bannerService";

export const useBanner = () => {
  const [banner, setBanner] = useState<BannerPayload | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadBanner = async () => {
      try {
        const remoteBanner = await fetchBanner();
        if (isMounted) {
          setBanner(remoteBanner);
        }
      } catch (error) {
        console.error("Failed to load banner content", error);
      }
    };

    loadBanner();

    return () => {
      isMounted = false;
    };
  }, []);

  return { banner };
};
